import type { ReactNode } from 'react';

import { IconBg2 } from '@ui/uikit/components/icons/mono/IconBg2';

type PredictionCardWrapperProps = {
  isLocked?: boolean;
  children: ReactNode;
};

export const PredictionCardWrapper = ({ isLocked, children }: PredictionCardWrapperProps) => {
  return isLocked ? (
    <div
      className="
          w-full h-full rounded-3xl
          border-2 border-base-border-pink-medium
          card-boxshadow-default relative overflow-hidden
      "
      style={{
        background:
          'linear-gradient(rgb(var(--colors-base-bg-tertiary-pink)), rgb(var(--colors-card-default-default-bg)))',
        zIndex: 1,
      }}
    >
      <IconBg2
        className="absolute h-[176px] -translate-x-[50%] left-[50%]"
        style={{ color: 'rgb(var(--colors-base-border-pink-medium))', zIndex: '-1' }}
      />
      {children}
    </div>
  ) : (
    <div
      className="w-full h-full rounded-3xl border-[1px] border-base-border-medium bg-card-default-default-bg relative"
      style={{
        zIndex: 1,
      }}
    >
      {children}
    </div>
  );
};
